'use client';

import { useSearchParams } from 'next/navigation';
import { Suspense } from 'react';

function EmbedSectionInner({
  children,
  className,
  embedClassName,
  'data-testid': testId,
}: {
  children: React.ReactNode;
  className: string;
  embedClassName: string;
  'data-testid'?: string;
}): React.JSX.Element {
  const searchParams = useSearchParams();
  const isEmbed = searchParams.get('embed') === '1';

  return (
    <section className={isEmbed ? embedClassName : className} data-testid={testId}>
      {children}
    </section>
  );
}

export function EmbedSection(props: {
  children: React.ReactNode;
  className: string;
  embedClassName: string;
  'data-testid'?: string;
}): React.JSX.Element {
  return (
    <Suspense fallback={<section className={props.className} data-testid={props['data-testid']} />}>
      <EmbedSectionInner {...props} />
    </Suspense>
  );
}
